import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import LamaForm from "./LamaForm";

import { createLamaForm } from "../../../../store/slices/lamaFormsSlice";
import { fetchPatient } from "../../../../store/slices/patientsSlice";

const AddLama = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();

    const caseId = state?.caseId ?? null;
    const patientId = state?.patientId ?? null;

    const [formData, setFormData] = useState({
        caseId,
        patientId,
        patientName: "",
        guardianName: "",
        relationWithPatient: "",
        guardianCnic: "",
        reasonForLama: "",
        otherReason: "",
        consultantName: "",
        diagnosis: "",
        date: "",
        time: "",
        prpRemarks: "",
    });

    useEffect(() => {
        if (patientId) {
            dispatch(fetchPatient(patientId))
                .unwrap()
                .then((patient) => {
                    if (patient) {
                        setFormData((prev) => ({
                            ...prev,
                            patientName: `${patient.first_name || ""} ${patient.last_name || ""}`.trim(),
                        }));
                    }
                })
                .catch((err) => console.error("Failed to prefill patient name for LAMA:", err));
        }
    }, [dispatch, patientId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 🔹 camelCase → snake_case mapper
    const buildPayload = () => ({
        case_id: formData.caseId,
        patient_id: formData.patientId,
        patient_name: formData.patientName,
        guardian_name: formData.guardianName,
        relation_with_patient: formData.relationWithPatient,
        guardian_cnic: formData.guardianCnic,
        reason_for_lama: formData.reasonForLama,
        other_reason: formData.otherReason,
        consultant_name: formData.consultantName,
        diagnosis: formData.diagnosis,
        date: formData.date,
        time: formData.time,
        prp_remarks: formData.prpRemarks,
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await dispatch(createLamaForm(buildPayload())).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "LAMA form created successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });

            navigate(`/cases/${caseId}/profile`, {
                state: { caseId, patientId },
            });
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: error?.message || "Failed to save LAMA form",
                icon: "error",
            });
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <LamaForm
                                formData={formData}
                                handleChange={handleChange}
                            />

                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-save-2-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddLama;
